/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EligibilityCheckProviderInfo
 */
export interface EligibilityCheckProviderInfo {
    /**
     * National Provider Identifier
     */
    npi?: string;
    /**
     * Last name of the provider (Community name)
     */
    lastName?: string;
    /**
     * Organization or facility name for facility-based requests
     */
    organizationName?: string;
}

/**
 * Check if a given object implements the EligibilityCheckProviderInfo interface.
 */
export function instanceOfEligibilityCheckProviderInfo(value: object): value is EligibilityCheckProviderInfo {
    return true;
}

export function EligibilityCheckProviderInfoFromJSON(json: any): EligibilityCheckProviderInfo {
    return EligibilityCheckProviderInfoFromJSONTyped(json, false);
}

export function EligibilityCheckProviderInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibilityCheckProviderInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'npi': json['npi'] == null ? undefined : json['npi'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
    };
}

export function EligibilityCheckProviderInfoToJSON(json: any): EligibilityCheckProviderInfo {
    return EligibilityCheckProviderInfoToJSONTyped(json, false);
}

export function EligibilityCheckProviderInfoToJSONTyped(value?: EligibilityCheckProviderInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'npi': value['npi'],
        'lastName': value['lastName'],
        'organizationName': value['organizationName'],
    };
}

